import { Box, Grid, Typography } from '@mui/material';
import { formatPounds } from '@acorn-portal/shared/src/utils';
import { useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';
import PriceBreakdown from '@acorn-portal/shared/src/components/display/price-breakdown';
import { MtaPaymentCollectionOption, PaymentProvider2 } from '@acorn-portal/shared/src/services/api';
import BraintreeCardPaymentSection from './braintree-card-payment-section';
import StripePaymentWrapper from './StripePaymentWrapper';

interface IProps {
	toggleModal: (open: boolean) => void;
	payInFullOption: MtaPaymentCollectionOption;
}

const CardPaymentOption = ({ toggleModal, payInFullOption }: IProps) => {
	const policy = useAppSelector((redux) => redux.fullPolicy);
	const midTermAdjustmentResponse = useAppSelector((redux) => redux.midTermAdjustmentResponse);

	return (
		<Box>
			<Grid
				container
				sx={{
					border: 1,
					borderColor: 'grey.300',
					p: 2,
					mb: 4,
					borderRadius: 2,
				}}
				maxWidth='md'
				margin='auto'
			>
				<Grid container sx={{ flexDirection: 'column' }}>
					<Grid sx={{ textAlign: { xs: 'left' } }}>
						<Typography component='h3' color='primary'>
							Single Card Payment
						</Typography>
						<Typography fontSize={44} fontWeight='bold' color='primary' lineHeight={1}>
							{formatPounds(payInFullOption.totalAmountPayable ?? 0)}
						</Typography>
						<Grid flex={1}>
							<Typography fontSize={16}>Payment Amount</Typography>
						</Grid>

						<PriceBreakdown
							price={payInFullOption.totalAmountPayable}
							fee={midTermAdjustmentResponse.coverDetails.fee}
							product={policy.product}
						/>
					</Grid>
				</Grid>
			</Grid>
			<Box
				maxWidth='md'
				margin='auto'
				sx={(theme) => ({
					paddingTop: 3,
					paddingBottom: 3,
					marginTop: 2,
					marginBottom: 2,
					borderRadius: 2,
					border: `1px solid ${theme.palette.divider}`,
					backgroundColor: `${theme.palette.background.paper}`,
					boxShadow: `0 4px 12px ${theme.palette.primary.main}10`,
					padding: 3,
					position: 'relative',
					'&::before': {
						content: '""',
						position: 'absolute',
						top: 0,
						left: 0,
						width: '100%',
						height: '4px',
						background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
						borderTopLeftRadius: 8,
						borderTopRightRadius: 8,
					},
				})}
			>
				{midTermAdjustmentResponse.existingCardPaymentMethods.length > 0 && (
					<Typography marginTop={4}>Please select an existing card for payment, or use a new card.</Typography>
				)}
				{midTermAdjustmentResponse.paymentProvider === PaymentProvider2.STRIPE ? (
					<StripePaymentWrapper payInFullOption={payInFullOption} toggleModal={toggleModal} />
				) : (
					<BraintreeCardPaymentSection payInFullOption={payInFullOption} toggleModal={toggleModal} />
				)}
			</Box>
		</Box>
	);
};

export default CardPaymentOption;
